import TopMenuDesktop from './components/TopMenuDesktop.vue';
import InitComponent from 'Modules/InitComponent';
import store from 'Stores/store';

const topMenuDesktop = document.getElementById('top-menu-desktop');
const initComponent = new InitComponent({
  selectors: topMenuDesktop,
  components: { TopMenuDesktop },
  template: '<TopMenuDesktop />',
  store,
});

initComponent.init();
